import * as React from "react";
import Modal from "../../ui/modal/Modal";
import CreateJobStatusForm from "../form/create/CreateJobStatusForm";

interface IComponentProps {
	/**
	 * On successful created job status callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

export default class CreateJobStatusModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Create Job Status"}>
				<CreateJobStatusForm onSuccess={this.props.onSuccess} onCancel={this.props.onCancel}/>
			</Modal>
		);
	}
}
